import { useContext, useEffect, useRef, useState } from "react";
import { FormattedDate, FormattedMessage } from "react-intl";
import { UIReducerActionType } from "../reducers/uiReducer";
import { DeviceContext } from "../contexts/DeviceContext";
import { UIContext } from "../contexts/UIContext";
import "../styles/DeviceDetailCard.css";

const DeviceDetailCard = () => {
  const [displayTipClass, setDisplayTipClass] = useState("");
  const [hideDetailClass, setHideDetailClass] = useState("");
  const { device } = useContext(DeviceContext);
  const { uiState, uiDispatch } = useContext(UIContext);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const { showDeviceDetail } = uiState;
  const activeDeviceList = device.filter(dev => dev.isActive === true);
  const activeDevice = activeDeviceList[0];

  useEffect(() => {
    if(canvasRef.current) {
      const canvasContext = canvasRef.current?.getContext('2d');
      canvasContext!.clearRect(0, 0, 118, 118);
    }
    if(activeDevice?.guid && canvasRef.current) {
      const canvasContext = canvasRef.current?.getContext('2d');
      const radius = 50, origin_x = 50, origin_y = 50;
      const alpha = -Math.PI / 2;
      const beta = (activeDevice.remainDays > 365 || activeDevice.remainDays < 0) ? (1 * Math.PI * 2) + alpha : ((activeDevice.remainDays / 365) * Math.PI * 2) + alpha;
      const color = activeDevice.remainDays > 0 ? "#55ad42" : "#e44e56";
      canvasContext!.fillStyle = color; 
      canvasContext!.beginPath();
      canvasContext!.moveTo(origin_x - radius * Math.cos(beta), origin_y + radius * Math.sin(beta));
      canvasContext!.lineTo(origin_x, origin_y);
      canvasContext!.lineTo(origin_x + radius * Math.cos(alpha), origin_y + radius * Math.sin(alpha));
      canvasContext!.arc(origin_x, origin_y, radius, alpha, -beta - Math.PI, true);
      canvasContext!.fill();
    }
  }, [activeDevice, canvasRef.current]);

  useEffect(()=> {
    showDeviceDetail ? setHideDetailClass("") : setHideDetailClass("devicedetailcard-hide");
  },[showDeviceDetail]);
  
  const onCloseClick = () => {
    uiDispatch({type: UIReducerActionType.SHOW_DETAIL, payload: false});
  };

  const showTip = () => {
    setDisplayTipClass("devicedetailcard-tip-show");
  };

  const hideTip = () => {
    setDisplayTipClass("");
  };

  const displayRemainDays = () => {
    if(activeDevice.isAutoRenewal) {
      return (
        <span className="devicedetailcard-remaindayspie-valid">
          <FormattedMessage id="license_vaild_subscription" />
        </span>
      );
    } else {
      if(activeDevice.remainDays > 0) {
        return (
          <>
            <span className="devicedetailcard-remaindayspie-days">{ activeDevice.remainDays }</span>
            <span className="devicedetailcard-remaindayspie-dayunit">
            { activeDevice.remainDays === 1 ? <FormattedMessage id="license_day" /> : <FormattedMessage id="license_days" /> }
            </span>
          </>
        );
      } else {
        return (
          <span className="devicedetailcard-remaindayspie-expired">
            <FormattedMessage id="license_expired" />
          </span>
        );
      }
    }
  };

  const displayExpirationDate = () => {
    if(activeDevice.isAutoRenewal) {
      return null;
    }
    return(
      <>
        { activeDevice.remainDays > 0 ? <FormattedMessage id="expires_on" /> : <FormattedMessage id="expired_on" /> }
          <span className="devicedetailcard-licensestatus-date">
            <FormattedDate
              value={ new Date(activeDevice.expirationDate * 1000) }
              year="numeric"
              month="long"
              day="2-digit"
            />
        </span>
      </>
    );
  };

  return activeDevice ? (
    <div className={`devicedetailcard ${hideDetailClass}`}>
      <h5 className="devicedetailcard-header">
        <FormattedMessage id="device_detail" />
      </h5>
      <div className="devicedetailcard-close" onClick={ onCloseClick }></div>
      <div className="devicedetailcard-divide-line"></div>
      <div className="devicedetailcard-device text-center">
        <div className="devicedetailcard-devicedetail">{ activeDevice.displayName }</div>
        { activeDevice.os !== "iOS" ? (
            <div className="devicedetailcard-devicedetail">
              <FormattedMessage id="unlock_key" />
              <span>{ activeDevice.unlockKey }</span>
              <div className="devicedetailcard-tipicon" onMouseEnter={ showTip } onMouseLeave={ hideTip }></div>
              <div className={`devicedetailcard-tipcontent ${displayTipClass}`}>
                <FormattedMessage id="unlock_key_wording" />
              </div>
            </div> ) : 
          null
        }
      </div>
      <div className="devicedetailcard-divide-line"></div>
      <div className="devicedetailcard-licensestatus">
        <FormattedMessage id={`product_name_${activeDevice.pid}`} />
        <div className="devicedetailcard-remaindayspie">
          <canvas ref= { canvasRef } className="devicedetailcard-remaindayspie-canvas" width="100" height="100"/>
          <div className="devicedetailcard-remaindayspie-cover"></div>
          <div className="devicedetailcard-remaindayspie-background"></div>
          <div className="devicedetailcard-remaindayspie-info">
            <p>
              { displayRemainDays() }
            </p>
          </div>
        </div>
        { displayExpirationDate() }
      </div>
    </div>
  ) : null;
};

export default DeviceDetailCard;
